module.exports = __webpack_public_path__ + "static/img/fire.084c138a.svg";